module.exports = __webpack_public_path__ + "static/img/risk_nor2.9c8b286.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/risk_nor2.png
// module id = 928
// module chunks = 1